/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-22 10:35:26
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noInstall: '未安装',
});
